import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '1726076948462501';
    if ((window as any).fbq) return;
    // Delay script injection to improve initial TBT
    const timer = setTimeout(() => {
      const f = window as any;
      f.fbq = function () {
        f.fbq.callMethod ? f.fbq.callMethod.apply(f.fbq, arguments) : f.fbq.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = f.fbq;
      f.fbq.push = f.fbq;
      f.fbq.loaded = true;
      f.fbq.version = '2.0';
      f.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', pixelId);
      f.fbq('track', 'PageView');
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  return <noscript data-id="element-151">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1726076948462501&ev=PageView&noscript=1" alt="" data-id="element-152" />
    </noscript>;
}